import { render } from "./SUV.vue?vue&type=template&id=eb29aa5a"
import script from "./SUV.vue?vue&type=script&lang=js"
export * from "./SUV.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/SUV.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb29aa5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb29aa5a', __exports__)) {
    api.reload('eb29aa5a', __exports__)
  }
  
  module.hot.accept("./SUV.vue?vue&type=template&id=eb29aa5a", () => {
    api.rerender('eb29aa5a', render)
  })

}


export default __exports__